<template>
  <div id="file" class="div_card">
    <div v-if="(-1==noInfo.isApproval)">
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else-if="(0==noInfo.isApproval)">
      <el-alert
        title="請先完成網路報名。"
        description=""
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <table class="w-100" style="background-color: azure; border: gray;" rules="all" bgcolor="#FFFFFF"
      v-else>
      <tbody>
        <tr>
          <td style="line-height: 2.5em; width: 10.1em; padding:0.1em;">考生姓名</td>
          <td style="width: 25em; padding:0.1em;">
            <span class="badge badge-info" style="font-size:1.25rem">{{noInfo.no}}</span>
          </td>
          <td colspan="2">
            <span class="ncut-base-form-button">
              <div class="ncut-base-form-button" style="text-align: center;"
                    v-if="isModify">
                <el-button type="success" @click="submit()">{{$t('message.Send_cmd')}}</el-button>
              </div>
            </span>
          </td>
        </tr>
        <tr v-if="0 == noInfo.count">
          <td style="padding: 1em;" colspan="4">
            <el-alert
              title="您目前沒有需要補件上傳，謝謝。"
              description=""
              type="info"
              close-text="…"
              show-icon
              :closable="false">
            </el-alert>
          </td>
        </tr>
        <tr v-if="0 < noInfo.count">
          <td style="padding:0; background:white;" colspan="4">
            <table style="margin-bottom: 0.1em; background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;" rules="all">
              <tbody>
                <tr v-if="(noInfo.info1!==null) && noInfo.info1.flag">
                  <td class="ncut-base-form-title ncut-require-title" style="padding:0.1em; width:10em; background:#e9d7df;">照片</td>
                  <td class="ncut-ipnut-form-text file_table_bc" colspan="3">
                    <el-upload
                      ref="upload"
                      action="./WebApi/Tools/UploadV2"
                      accept=".jpg"
                      :name="'f' + user.dId + '_10'"
                      :show-file-list="false"
                      :drag="true"
                      :on-success="handleAvatarSuccess"
                      :before-upload="onBeforeUploadF1">
                      <img v-if="imageUrl!=null" :src="imageUrl" class="avatar"/>
                      <img v-else-if="(imageUrl== null) && (noInfo.info1!==null) && (noInfo.info1.info!=null) && (noInfo.info1.info.length>0) && noInfo.info1.info[0].img!=null"
                        :src="noInfo.info1.info[0].img" class="avatar"/>
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </td>
                </tr>
                <tr v-if="(noInfo.info2!==null) && noInfo.info2.flag">
                  <td class="ncut-base-form-title ncut-require-title" style="width:10em; background:#e9d7df;">學歷證明文件</td>
                  <td class="ncut-ipnut-form-text file_table_bc" style="width:30em;">
                    <el-upload
                      ref="upload"
                      list-type="picture"
                      action="./WebApi/Tools/UploadV2"
                      accept=".pdf"
                      :name="'f' + user.dId + '_2' + (info2==null? 0:info2.length)"
                      :on-success="handleAvatarSuccess"
                      :on-remove="handleChangeF2"
                      :before-upload="onBeforeUpload">
                      <el-button size="small" type="primary"
                        @click="fileIdx = 20 + (info2==null? 0:info2.length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                  </td>
                  <td class="ncut-ipnut-form-text file_table_bc" colspan="2">
                    <ul style="clear:both" class="response"
                      v-if="(noInfo.info2.info!=null) && (noInfo.info2.info.length > 0)" >
                      <li class="sel-file"
                        v-for="(f,index) in filterImg2List" :key="index" :index="'0'+index" :name="'P2'+index">
                        <a href="#" @click="setUrl(f)">
                          <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                          <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                        </a>
                        &nbsp;&nbsp;
                        <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                          <span v-if="f.status=='R'">
                            刪除…
                          </span>
                          <el-button icon="el-icon-delete" circle
                            @click="setDelFlag(f);"
                            v-else></el-button>
                        </el-tooltip>
                      </li>
                    </ul>
                    <span v-else>
                      無
                    </span>
                  </td>
                </tr>
                <tr v-if="(noInfo.info5!==null) && noInfo.info5.flag">
                  <td class="ncut-base-form-title ncut-require-title" style="width:10em; background:#e9d7df;">身分證影本</td>
                  <td class="ncut-ipnut-form-text file_table_bc" style="width:30em;">
                    <el-upload
                      list-type="picture"
                      ref="upload"
                      action="./WebApi/Tools/UploadV2"
                      accept=".jpg,.pdf"
                      :name="'f' + user.dId + '_8' + (info5==null? 0: info5.length)"
                      :on-success="handleAvatarSuccess"
                      :on-remove="handleChangeF3"
                      :before-upload="onBeforeUpload">
                      <el-button size="small" type="primary"
                        @click="fileIdx = 30 + (info5==null? 0:info5.length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                  </td>
                  <td class="ncut-ipnut-form-text file_table_bc" colspan="2">
                    <ul style="clear:both" class="response"
                      v-if="(noInfo.info5.info!=null) && (noInfo.info5.info.length > 0)">
                      <li class="sel-file"
                        v-for="(f,index) in filterImg5List" :key="index" :index="'0'+index" :name="'P5'+index">
                        <a href="#" @click="setUrl(f)">
                          <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                          <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                        </a>
                        &nbsp;&nbsp;
                        <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                          <span v-if="f.status=='R'">
                            刪除…
                          </span>
                          <el-button icon="el-icon-delete" circle
                            @click="setDelFlag(f);"
                            v-else></el-button>
                        </el-tooltip>
                      </li>
                    </ul>
                    <span v-else>
                      無
                    </span>
                  </td>
                </tr>
                <tr v-if="(noInfo.info6!==null) && noInfo.info6.flag">
                  <td class="ncut-base-form-title ncut-require-title" style="width:10em; background:#e9d7df;">歷年成績單/考生資格審查申請書</td>
                  <td class="ncut-ipnut-form-text file_table_bc" style="width:30em;">
                    <el-upload
                      list-type="picture"
                      ref="upload"
                      action="./WebApi/Tools/UploadV2"
                      accept=".pdf"
                      :name="'f' + user.dId + '_3' + (info6==null? 0: info6.length)"
                      :on-success="handleAvatarSuccess"
                      :on-remove="handleChangeF11"
                      :before-upload="onBeforeUpload">
                      <el-button size="small" type="primary"
                        @click="fileIdx = 60 + (info6==null? 0:info6.length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                  </td>
                  <td class="ncut-ipnut-form-text file_table_bc" colspan="2">
                    <ul style="clear:both" class="response"
                      v-if="(noInfo.info6.info!=null) && (noInfo.info6.info.length > 0)">
                      <li class="sel-file"
                        v-for="(f,index) in filterImg6List" :key="index" :index="'0'+index" :name="'P6'+index">
                        <a href="#" @click="setUrl(f)">
                          <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                          <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                        </a>
                        &nbsp;&nbsp;
                        <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                          <span v-if="f.status=='R'">
                            刪除…
                          </span>
                          <el-button icon="el-icon-delete" circle
                            @click="setDelFlag(f);"
                            v-else></el-button>
                        </el-tooltip>
                      </li>
                    </ul>
                    <span v-else>
                      無
                    </span>
                  </td>
                </tr>
                <tr v-if="(noInfo.info7!==null) && noInfo.info7.flag">
                  <td class="ncut-base-form-title ncut-require-title" style="width:10em; background:#e9d7df;">在職證明</td>
                  <td class="ncut-ipnut-form-text file_table_bc" style="width:30em;">
                    <el-upload
                      list-type="picture"
                      ref="upload"
                      action="./WebApi/Tools/UploadV2"
                      accept=".pdf"
                      :name="'f' + user.dId + '_12' + (info7==null? 0: info7.length)"
                      :on-success="handleAvatarSuccess"
                      :on-remove="handleChangeF12"
                      :before-upload="onBeforeUpload">
                      <el-button size="small" type="primary"
                        @click="fileIdx = 70 + (info7==null? 0:info7.length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                  </td>
                  <td class="ncut-ipnut-form-text file_table_bc" colspan="2">
                    <ul style="clear:both" class="response"
                      v-if="(noInfo.info7.info!=null) && (noInfo.info7.info.length > 0)">
                      <li class="sel-file"
                        v-for="(f,index) in filterImg7List" :key="index" :index="'0'+index" :name="'P6'+index">
                        <a href="#" @click="setUrl(f)">
                          <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                          <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                        </a>
                        &nbsp;&nbsp;
                        <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                          <span v-if="f.status=='R'">
                            刪除…
                          </span>
                          <el-button icon="el-icon-delete" circle
                            @click="setDelFlag(f);"
                            v-else></el-button>
                        </el-tooltip>
                      </li>
                    </ul>
                    <span v-else>
                      無
                    </span>
                  </td>
                </tr>
                <tr v-if="(noInfo.info8!==null) && noInfo.info8.flag">
                  <td class="ncut-base-form-title ncut-require-title" style="width:10em; background:#e9d7df;">身心障礙證明</td>
                  <td class="ncut-ipnut-form-text file_table_bc" style="width:30em;">
                    <el-upload
                      list-type="picture"
                      ref="upload"
                      action="./WebApi/Tools/UploadV2"
                      accept=".pdf"
                      :name="'f' + user.dId + '_13' + (info8==null? 0: info8.length)"
                      :on-success="handleAvatarSuccess"
                      :on-remove="handleChangeF13"
                      :before-upload="onBeforeUpload">
                      <el-button size="small" type="primary"
                        @click="fileIdx = 80 + (info8==null? 0:info8.length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                  </td>
                  <td class="ncut-ipnut-form-text file_table_bc" colspan="2">
                    <ul style="clear:both" class="response"
                      v-if="(noInfo.info8.info!=null) && (noInfo.info8.info.length > 0)">
                      <li class="sel-file"
                        v-for="(f,index) in filterImg8List" :key="index" :index="'0'+index" :name="'P6'+index">
                        <a href="#" @click="setUrl(f)">
                          <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                          <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                        </a>
                        &nbsp;&nbsp;
                        <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                          <span v-if="f.status=='R'">
                            刪除…
                          </span>
                          <el-button icon="el-icon-delete" circle
                            @click="setDelFlag(f);"
                            v-else></el-button>
                        </el-tooltip>
                      </li>
                    </ul>
                    <span v-else>
                      無
                    </span>
                  </td>
                </tr>
                <tr v-if="(noInfo.info3!==null) && noInfo.info3.flag">
                  <td class="ncut-base-form-title ncut-require-title" style=" width:10em; background:#e9d7df;">
                    特種生證明文件
                    <!-- <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                       class="btn btn-info btn-md"
                       @click="addDocRow(0)">
                      <i class="el-icon-circle-plus-outline"></i>新增證明文件
                    </a> -->
                  </td>
                  <td class="ncut-ipnut-form-text file_table_bc" colspan="3">
                    <table class="table table-bordered table-striped" style="background:#FFFFFF;">
                      <tbody>
                        <tr v-for="(item,sIndex) in noInfo.info3.info" :key="sIndex" :index="'0'+sIndex" :name="'S'+sIndex">
                          <td style="width: 30em;">
                            證明文件{{sIndex+1}}
                              <el-input v-model="item.descr" placeholder="請輸入文件名稱" style="width: 10em; display: inline; " maxlength="20"></el-input>
                          </td>
                          <td style="margin:0;">
                            <div>
                              <el-tooltip class="item" style="display: initial;" effect="dark" :content="'上傳特種生證明文件'" placement="right-end">
                              <el-upload
                                ref="upload"
                                list-type="picture"
                                action="./WebApi/Tools/UploadV2"
                                accept=".pdf"
                                :name="'f' + user.dId + '_5' + sIndex + (info3==null || info3[sIndex]==null? 0: info3[sIndex].length)"
                                :on-success="handleAvatarSuccess"
                                :on-remove="handleChangeF4"
                                :before-upload="onBeforeUpload"
                                v-if="item.status!='R'">
                                <el-button size="small" type="primary"
                                  @click="fileIdx = 400 + sIndex*10 + (info3==null || info3[sIndex]==null? 0: info3[sIndex].length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                              </el-upload>
                              </el-tooltip>
                              <ul style="clear:both" class="response"
                                v-if="item.info!=null && item.info.length > 0">
                                <li class="sel-file"
                                  v-for="(f1,f1Index) in item.info" :key="f1Index" :index="'0'+f1Index" :name="'F4'+f1Index">
                                  <a href="#" @click="setUrl(f1)">
                                    <img v-if="f1.img != null" :src="f1.img" style="width: 2em;" />
                                    <img v-if="f1.img == null" src="@/assets/images/disk.png" /> {{f1.name}}{{f1.ext}}
                                  </a>
                                  &nbsp;&nbsp;
                                  <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                                    <span v-if="f1.status=='R'">
                                      刪除…
                                    </span>
                                    <el-button icon="el-icon-delete" circle
                                      @click="setModifyFlag(item);setDelFlag(f1);"
                                      v-else></el-button>
                                  </el-tooltip>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr >
                          <td class="ncut-ipnut-form-text file_table_bc" style="margin: 0.5em" colspan="3">
                            <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                              class="btn btn-info btn-md"
                              @click="addDocRow(0)">
                              <i class="el-icon-circle-plus-outline"></i>新增證明文件
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr v-if="(noInfo.othersInfo!==null) && noInfo.othersInfo.flag">
                  <td class="ncut-base-form-title ncut-require-title" style=" width:10em; background:#e9d7df;">
                    其它文件
                    <!-- <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                       class="btn btn-info btn-md"
                       @click="addDocRow(1)">
                      <i class="el-icon-circle-plus-outline"></i>新增其他證明文件
                    </a> -->
                  </td>
                  <td class="ncut-ipnut-form-text file_table_bc" style="margin: 0.5em" colspan="3">
                    <table class="table table-bordered table-striped" style="margin: 0; background:#e4dfd7;">
                      <tbody>
                        <tr v-for="(item,oIndex) in noInfo.othersInfo.info" :key="oIndex" :index="'0'+oIndex" :name="'O'+oIndex">
                          <td style="width: 30em;">
                            其他文件{{oIndex+1}}
                              <el-input v-model="item.descr" placeholder="請輸入文件名稱" style="width: 10em; display: inline; " maxlength="20"></el-input>
                          </td>
                          <td style="margin:0;">
                            <div>
                              <el-tooltip class="item" style="display: initial;" effect="dark" :content="'上傳其他證明文件'" placement="right-end">
                                <el-upload
                                  ref="upload"
                                  list-type="picture"
                                  action="./WebApi/Tools/UploadV2"
                                  accept=".pdf"
                                  :name="'f' + user.dId + '_7' + oIndex + (othInfo==null || othInfo[oIndex]==null? 0: othInfo[oIndex].length)"
                                  :on-success="handleAvatarSuccess"
                                  :on-remove="handleChangeF6"
                                  :before-upload="onBeforeUpload"
                                  v-if="item.status!='R'">
                                  <el-button size="small" type="primary"
                                    @click="fileIdx = 500 + oIndex*10 + (othInfo==null || othInfo[oIndex]==null? 0: othInfo[oIndex].length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                                </el-upload>
                              </el-tooltip>
                              <ul style="clear:both" class="response"
                                  v-if="item.info!=null && item.info.length > 0">
                                <li class="sel-file"
                                  v-for="(f1, f1Index) in item.info" :key="f1Index" :index="'0'+f1Index" :name="'F6' + f1Index">
                                  <a href="#" @click="setUrl(f1)">
                                    <img v-if="f1.img != null" :src="f1.img" style="width: 2em;" />
                                    <img v-if="f1.img == null" src="@/assets/images/disk.png" /> {{f1.name}}{{f1.ext}}
                                  </a>
                                  &nbsp;&nbsp;
                                  <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                                    <span v-if="f1.status=='R'">
                                      刪除…
                                    </span>
                                    <el-button icon="el-icon-delete" circle
                                      @click="setModifyFlag(item); setDelFlag(f1);"
                                      v-else></el-button>
                                  </el-tooltip>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr >
                          <td class="ncut-ipnut-form-text file_table_bc" style="margin: 0.5em" colspan="3">
                            <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                              class="btn btn-info btn-md"
                              @click="addDocRow(1)">
                              <i class="el-icon-circle-plus-outline"></i>新增其他證明文件
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr v-if="(noInfo.majorInfo!==null) && noInfo.majorInfo.flag">
                  <td class="ncut-base-form-title ncut-require-title" style="width:10em; background:#e9d7df;">
                    書審資料
                    <!-- <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                       class="btn btn-info btn-md"
                       @click="addDocRow(2)">
                      <i class="el-icon-circle-plus-outline"></i>新增書審資料
                    </a> -->
                  </td>
                  <td class="ncut-ipnut-form-text file_table_bc" style="margin: 0.5em" colspan="3">
                    <table class="table table-bordered table-striped" style="margin: 0; background:#e4dfd7;">
                      <tbody>
                        <tr v-for="(item,maIndex) in noInfo.majorInfo.info" :key="maIndex" :index="'0'+maIndex" :name="'MA'+maIndex">
                          <td style="width: 30em;">
                            <span style="font-size:small;">書審資料</span> {{maIndex+1}}.
                              <el-input v-model="item.descr" placeholder="請輸入文件名稱" style="width: 10em; display: inline; " maxlength="20"></el-input>
                          </td>
                          <td style="margin:0;vertical-align:middle;">
                            <div>
                              <el-tooltip class="item" style="display: initial;" effect="dark" :content="'上傳書審資料'" placement="right-end">
                                <el-upload
                                  ref="upload"
                                  list-type="picture"
                                  action="./WebApi/Tools/UploadV2"
                                  accept=".pdf"
                                  :name="'f' + user.dId + '_9' + maIndex + (majInfo==null || majInfo[maIndex]==null? 0: majInfo[maIndex].length)"
                                  :on-success="handleAvatarSuccess"
                                  :on-remove="handleChangeF7"
                                  :before-upload="onBeforeUpload10M"
                                  v-if="item.status!='R'">
                                  <el-button size="small" type="primary"
                                    @click="fileIdx = 600 + maIndex*10 + (majInfo==null || majInfo[maIndex]==null? 0: majInfo[maIndex].length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                                </el-upload>
                              </el-tooltip>
                              <ul style="clear:both" class="response"
                                  v-if="item.info!=null && item.info.length > 0">
                                <li class="sel-file"
                                  v-for="(f1, f1Index) in item.info" :key="f1Index" :index="'0'+f1Index" :name="'F6' + maIndex + f1Index">
                                  <a href="#" @click="setUrl(f1)">
                                    <img v-if="f1.img != null" :src="f1.img" style="width: 2em;" />
                                    <img v-if="f1.img == null" src="@/assets/images/disk.png" /> {{f1.name}}{{f1.ext}}
                                  </a>
                                  &nbsp;&nbsp;
                                  <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                                    <span v-if="f1.status=='R'">
                                      刪除…
                                    </span>
                                    <el-button icon="el-icon-delete" circle
                                      @click="setModifyFlag(item); setDelFlag(f1);"
                                      v-else></el-button>
                                  </el-tooltip>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr >
                          <td class="ncut-ipnut-form-text file_table_bc" style="margin: 0.5em" colspan="3">
                            <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                              class="btn btn-info btn-md"
                              @click="addDocRow(2)">
                              <i class="el-icon-circle-plus-outline"></i>新增書審資料
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr v-if="(noInfo.minorInfo!==null) && noInfo.minorInfo.flag">
                  <td class="ncut-base-form-title ncut-require-title" style="background:#e9d7df;">
                    選繳資料
                    <!-- <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                       class="btn btn-info btn-md"
                       @click="addDocRow(3)">
                      <i class="el-icon-circle-plus-outline"></i>新增選繳資料
                    </a> -->
                  </td>
                  <td class="ncut-ipnut-form-text file_table_bc" style="margin: 0.5em" colspan="3">
                    <table class="table table-bordered table-striped" style="margin: 0; background:#e4dfd7;">
                      <tbody>
                        <tr v-for="(item,miIndex) in noInfo.minorInfo.info" :key="miIndex" :index="'0'+miIndex" :name="'MI'+miIndex">
                          <td style="width: 30em;">
                            <span style="font-size:small;">選繳資料</span> {{miIndex+1}}.
                              <el-input v-model="item.descr" placeholder="請輸入文件名稱" style="width: 10em; display: inline; " maxlength="20"></el-input>
                          </td>
                          <td style="margin:0;vertical-align:middle;">
                            <div>
                              <el-tooltip class="item" style="display: initial;" effect="dark" :content="'上傳選繳資料'" placement="right-end">
                                <el-upload
                                  ref="upload"
                                  list-type="picture"
                                  action="./WebApi/Tools/UploadV2"
                                  accept=".pdf"
                                  :name="'f' + user.dId + '_10' + miIndex + (minInfo==null || minInfo[miIndex]==null? 0: minInfo[miIndex].length)"
                                  :on-success="handleAvatarSuccess"
                                  :on-remove="handleChangeF8"
                                  :before-upload="onBeforeUpload10M"
                                  v-if="item.status!='R'">
                                  <el-button size="small" type="primary"
                                    @click="fileIdx = 700 + miIndex*10 + (minInfo==null || minInfo[miIndex]==null? 0: minInfo[miIndex].length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                                </el-upload>
                              </el-tooltip>
                              <ul style="clear:both" class="response"
                                  v-if="item.info!=null && item.info.length > 0">
                                <li class="sel-file"
                                  v-for="(f1,index7) in item.info" :key="index7" :index="'0'+index7" :name="'F7' + miIndex + index7">
                                  <a href="#" @click="setUrl(f1)">
                                    <img v-if="f1.img != null" :src="f1.img" style="width: 2em;" />
                                    <img v-if="f1.img == null" src="@/assets/images/disk.png" /> {{f1.name}}{{f1.ext}}
                                  </a>
                                  &nbsp;&nbsp;
                                  <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                                    <span v-if="f1.status=='R'">
                                      刪除…
                                    </span>
                                    <el-button icon="el-icon-delete" circle
                                      @click="setModifyFlag(item); setDelFlag(f1);"
                                      v-else></el-button>
                                  </el-tooltip>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr >
                          <td class="ncut-ipnut-form-text file_table_bc" style="margin: 0.5em" colspan="3">
                            <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                              class="btn btn-info btn-md"
                              @click="addDocRow(3)">
                              <i class="el-icon-circle-plus-outline"></i>新增選繳資料
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-show="img!=''">
              <div v-if="fileType!=1">
                <pdf :src="img" scale="page-width" style="width:100%;margin:20px auto;"></pdf>
              </div>
              <div class="viewer-wrapper" style="overflow:hidden;"
                v-else>
                <viewer :images="images"
                  @inited="inited"
                  class="viewer" ref="viewer">
                  <template slot-scope="scope">
                    <figure class="images">
                      <div class="image-wrapper" v-for="{source, thumbnail} in scope.images" :key="source">
                        <img class="image" style="max-width: 68em; max-height:80em;"
                            :src="thumbnail" :data-source="source" :alt="source.split('?image=').pop()"/>
                      </div>
                    </figure>
                  </template>
                </viewer>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'file',
  data () {
    return {
      count: 0,
      imageUrl: null,
      fileIdx: -1,
      info1: null,
      info2: null,
      info3: null,
      info5: null,
      info6: null,
      info7: null,
      info8: null,
      othInfo: null,
      majInfo: null,
      minInfo: null,
      noInfo: {
        info1: null,
        info2: null,
        info3: null,
        info5: null,
        info6: null,
        info7: null,
        info8: null,
        othersInfo: null,
        majorInfo: null,
        minorInfo: null,
        isApproval: -1,
        count: 0
      },
      isModify: false,
      fileType: 0,
      images: [],
      img: '',
    }
  },
  components: {
    pdf
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    },
    filterImg2List: function () {
      if (null != this.noInfo.info2) {
        var shoppingList = this.noInfo.info2.info;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    // filterImg3List: function () {
    //   if (null != this.noInfo.info3) {
    //     var shoppingList = this.noInfo.info3.info;
    //       return shoppingList.filter(function (item) {
    //         return item.status!='R'
    //     });
    //   }
    //   return [];
    // },
    filterImg5List: function () {
      if (null != this.noInfo.info5) {
        var shoppingList = this.noInfo.info5.info;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    filterImg6List: function () {
      if (null != this.noInfo.info6) {
        var shoppingList = this.noInfo.info6.info;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    filterImg7List: function () {
      if (null != this.noInfo.info7) {
        var shoppingList = this.noInfo.info7.info;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    filterImg8List: function () {
      if (null != this.noInfo.info8) {
        var shoppingList = this.noInfo.info8.info;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    }
  },
  methods: {
    clearFileInfo(){
      this.info1= null;
      this.info2= null;
      this.info3= null;
      this.info5= null;
      this.info6= null;
      this.info7= null;
      this.info8= null;
      this.othInfo= null;
      this.majInfo= null;
      this.minInfo= null;
      this.noInfo= null;
      this.isModify=false;
    },
    isNull(data) {
      return ((data != null) && (data != undefined) && (data != "null") ? false : true);
    },
    setUrl(data) {
        this.img = './WebApi/Tools/GetDocument/'+data.rowId
        if (0 == data.type.indexOf("image")) {
          this.fileType = 1;
          this.images = [];
          this.images.push({
            thumbnail: this.img,
            source: this.img
          })
        } else {
          this.fileType = 0;
          this.images = [];
        }
    },
    inited (viewer) {
      this.$viewer = viewer
    },
    setDelFlag(item) {
      item.status='R';
      this.isModify = true;
    },
    setModifyFlag(item) {
      if (item.status != 'A') {
        item.status = 'M';
      }
    },
    isSuccess(str) {
      return ((str == "true") || (str == "True") || (str == true) ? true : false);
    },
    checkFileInfo(tInfo, inpInfo) {
      var len = tInfo.length;
      for (var it = 0; it < len; it++) {
        if (tInfo[it].status == 'A' || tInfo[it].rowId.length > 0) {
          inpInfo.push(tInfo[it]);
        }
      }
    },
    setPhotoSet(noInfo, tmpInfo) {
      var aLen = tmpInfo.length;
      for (var i = 0; i < aLen; i++) {
        if ((null != tmpInfo[i]) && (tmpInfo[i].length>0)) {
           noInfo.info[i].status = (noInfo.info[i].status!='A'?'M':noInfo.info[i].status);
          if (null == noInfo.info[i].info) {
            noInfo.info[i].info = tmpInfo[i];
          } else {
            var nLen = tmpInfo[i].length;
            for (var j = 0; j < nLen; j++) {
              noInfo.info[i].info.push(tmpInfo[i][j]);
            }
          }
        }
      }
    },
    setPhoto() {
      // 大頭照
      if (null != this.info1) {
        if (null == this.noInfo.info1.info) {
          this.noInfo.info1.info = [];
        } else {
          var len = this.noInfo.info1.info.length;
          for (var it = 0; it < len; it++) {
            this.noInfo.info1.info[it].status = 'D';
          }
        }

        if (this.info1.status == 'A' || this.info1.rowId.length > 0) {
          this.noInfo.info1.info.push(this.info1);
        }
      }

      // 學歷證明文件
      if (null != this.info2) {
        if (null == this.noInfo.info2.info) {
          this.noInfo.info2.info = [];
        } else {
          // var len = this.noInfo.info2.info.length;
          // for (var it = 0; it < len; it++) {
          //   this.noInfo.info2.info[it].status = 'D';
          // }
        }
        this.checkFileInfo(this.info2, this.noInfo.info2.info);
      }

      // 特種生證明文件
      // if (null != this.info3) {
      //   if (null == this.noInfo.info3.info) {
      //     this.noInfo.info3.info = [];
      //   }
      //   this.setPhotoSet(this.noInfo.info3, this.info3);
      // }
      if (null != this.info3) {
        this.setPhotoSet(this.noInfo.info3, this.info3);
      }

      // 身分證影本
      if (null != this.info5) {
        if (null == this.noInfo.info5.info) {
          this.noInfo.info5.info = [];
        }
        this.checkFileInfo(this.info5, this.noInfo.info5.info);
      }

      // 在校成績
      if (null != this.info6) {
        if (null == this.noInfo.info6.info) {
          this.noInfo.info6.info = [];
        }
        this.checkFileInfo(this.info6, this.noInfo.info6.info);
      }

      // 修業計畫
      if (null != this.info7) {
        if (null == this.noInfo.info7.info) {
          this.noInfo.info7.info = [];
        }
        this.checkFileInfo(this.info7, this.noInfo.info7.info);
      }

      // 身心障礙證明
      if (null != this.info8) {
        if (null == this.noInfo.info8.info) {
          this.noInfo.info8.info = [];
        }
        this.checkFileInfo(this.info8, this.noInfo.info8.info);
      }

      // 其他文件
      if (null != this.othInfo) {
        this.setPhotoSet(this.noInfo.othersInfo, this.othInfo);
      }

      // 書審資料
      if (null != this.majInfo) {
        this.setPhotoSet(this.noInfo.majorInfo, this.majInfo);
      }

      // 選繳資料
      if (null != this.minInfo) {
        this.setPhotoSet(this.noInfo.minorInfo, this.minInfo);
      }
    },
    loadFileList() {
      var vm = this
      this.$http.get('./WebApi/Apply/GetFileInfo/'.concat(this.user.dId))
                .then(function(response) {
                  if (response.data != null) {
                    vm.noInfo = response.data
                  } else {
                    //vm.$message.error('對不起,讀取成績資料失敗');
                    vm.$notify.error({
                                      title: vm.$t('message.Error_txt'),
                                      dangerouslyUseHTMLString: true,
                                      message: '<strong>對不起,讀取<i style="background:yellow;">成績資料</i>失敗</strong>',
                                      offset: 150
                                    });
                  }
                })
                .catch(function (error) {
                  //vm.$message.error('對不起,網路連線失敗');
                  vm.$notify.error({
                                    title: vm.$t('message.Error_txt'),
                                    dangerouslyUseHTMLString: true,
                                    message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                    offset: 150
                                  });
                });
    },
    submit() {
      let vm = this;
      this.setPhoto();
      this.$http.put('./WebApi/Apply/SetFileInfo',this.noInfo)
                .then((response) =>{
                  if (true == this.isSuccess(response.data)) {
                    vm.$notify({
                                title: vm.$t('message.Success_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>恭喜您,存檔成功</strong>',
                                type: 'success',
                                offset: 150
                              });
                    this.clearFileInfo();
                    this.loadFileList();
                    const mainImg = this.$refs.upload;
                    if (mainImg && mainImg.length) {
                      mainImg.forEach(item => {
                        item.clearFiles();
                      })
                    }
                  } else {
                    //vm.$message.error('對不起,網路連線失敗' + error);
                    vm.$notify.error({
                                      title: vm.$t('message.Error_txt'),
                                      message: '對不起,網路連線失敗',
                                      offset: 150
                                    });
                  }
                })
                .catch(function (error) {
                  //vm.$message.error('對不起,網路連線失敗');
                  vm.$notify.error({
                                    title: vm.$t('message.Error_txt'),
                                    dangerouslyUseHTMLString: true,
                                    message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                    offset: 150
                                  });
                });
    },
    onBeforeUploadF1(file)
    {
      this.fileIdx = 10;
      return this.onBeforeUpload(file);
    },
    onBeforeUpload(file)
    {
      this.fileData = file;
      //var imgLst = (10 == this.fileIdx ? ['image/jpeg'] : ['image/jpeg', 'application/pdf']);
      var imgLst = ['image/jpeg'];
      if(10 == this.fileIdx){
        imgLst = ['image/jpeg'];
      }else if(20 == this.fileIdx){
        imgLst = ['application/pdf'];
      }else if(30 == this.fileIdx){
        imgLst = ['image/jpeg', 'application/pdf'];
      }else {
        imgLst = ['application/pdf'];
      }
      var isIMAGE = true;

      const isLt2M = file.size / 1024 / 1024 < 2;
      //全部改為10M
      const isLt10M = file.size / 1024 / 1024 < 10;
      if ((0 < imgLst.length) && (0 > imgLst.indexOf(file.type))) {
        var msg = "檔案格式不支援 (檔案限制為 ";
        for (var i = 0; i < imgLst.length; i++) {
          msg += ".".concat(imgLst[i]);
        }
        msg += ")!";
        isIMAGE = false;
        //this.$message.error(msg);
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            message: msg,
                            offset: 150
                          });
      }
      if (!isLt10M) {
        //this.$message.error('檔案大小請勿超過 2MB!');
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>檔案大小請勿超過<i style="background:yellow;">10MB</i>!</strong>',
                            offset: 150
                          });
      }

      return (isIMAGE && isLt10M);
    },
    onBeforeUpload10M(file)
    {
      this.fileData = file;
      var imgLst = ['application/pdf'];
      var isIMAGE = true;

      const isLt10M = file.size / 1024 / 1024 < 10;
      if ((0 < imgLst.length) && (0 > imgLst.indexOf(file.type))) {
        var msg = "檔案格式不支援 (檔案限制為 ";
        for (var i = 0; i < imgLst.length; i++) {
          msg += ".".concat(imgLst[i]);
        }
        msg += ")!";
        isIMAGE = false;
        //this.$message.error(msg);
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            message: msg,
                            offset: 150
                          });
      }
      if (!isLt10M) {
        //this.$message.error('檔案大小請勿超過 10MB!');
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>檔案大小請勿超過<i style="background:yellow;">10MB</i>!</strong>',
                            offset: 150
                          });
      }

      return (isIMAGE && isLt10M);
    },
    generateThumb(file) {
      if (file != null) {
        let vm = this;
        var res = file.name.split("\\");
        var retLen = res.length;
        var name = res[retLen - 1];
        var fnName = name.split(".");
        this.$http.get("./WebApi/Tools/GetImageV2/f".concat(this.user.dId).concat("_").concat(this.fileIdx))
                  .then((response) => {
                        if (!vm.isNull(response.data)) {
                            vm.imageUrl = response.data;
                        }
                  });
      }
    },
    handleAvatarSuccess(res, file) {
      var nmObj = file.response[0].name.trim().split('\\');
      var objLen = nmObj.length;
      var idx = Math.floor(this.fileIdx / 10);
      if (file.response[0].type == 'image/jpeg') {
        file.response[0].ext = '.jpg';
        if (idx == 1) {
          this.generateThumb(file.response[0]);
        }
      } else if (file.response[0].type == 'application/pdf') {
        file.response[0].ext = '.pdf';
      }
      this.isModify = true;
      switch(idx) {
        case 1: // 大頭照
                this.info1 = file.response[0];
                break;
        case 2: // 學歷證明文件
                if (this.info2 != null) {
                  this.info2.push(file.response[0]);
                } else {
                  this.info2 = [file.response[0]];
                }
                break;
        case 3: // 身分證影本
                if (this.info5 != null) {
                  this.info5.push(file.response[0]);
                } else {
                  this.info5 = [file.response[0]];
                }
                break;
        // case 4: // 特種生證明文件
        //         if (this.info3 != null) {
        //           this.info3.push(file.response[0]);
        //         } else {
        //           this.info3 = [file.response[0]];
        //         }
        //         break;
        case 6: // 歷年成績單
                if (this.info6 != null) {
                  this.info6.push(file.response[0]);
                } else {
                  this.info6 = [file.response[0]];
                }
                break;
        case 7: // 在職證明
                if (this.info7 != null) {
                  this.info7.push(file.response[0]);
                } else {
                  this.info7 = [file.response[0]];
                }
                break;
        case 8: // 身心障礙證明
                if (this.info8 != null) {
                  this.info8.push(file.response[0]);
                } else {
                  this.info8 = [file.response[0]];
                }
                break;
        default:
                if ((this.fileIdx >= 400) && (this.fileIdx < 500)) {  // 特種生證明文件
                  var idx = Math.floor((this.fileIdx - 400)/10);
                  var aLen = ((this.info3 != null) && (0 < this.info3.length) ? this.info3.length : 0);

                  if (this.info3 == null) {
                    this.info3 = [];
                  }

                  if (aLen <= idx) {
                    for (var x = aLen; x <= idx; x++) {
                      this.info3[x] = [];
                    }
                  }

                  if (this.info3[idx] != null) {
                    this.info3[idx].push(file.response[0]);
                  } else {
                    this.info3[idx] = [file.response[0]];
                  }
                } else if ((this.fileIdx >= 500) && (this.fileIdx < 600)) {  // 其他證明文件
                  var idx = Math.floor((this.fileIdx - 500)/10);
                  var aLen = ((this.othInfo != null) && (0 < this.othInfo.length) ? this.othInfo.length : 0);

                  if (this.othInfo == null) {
                    this.othInfo = [];
                  }

                  if (aLen <= idx) {
                    for (var x = aLen; x <= idx; x++) {
                      this.othInfo[x] = [];
                    }
                  }

                  if (this.othInfo[idx] != null) {
                    this.othInfo[idx].push(file.response[0]);
                  } else {
                    this.othInfo[idx] = [file.response[0]];
                  }
                } else if ((this.fileIdx >= 600) && (this.fileIdx < 700)) {  // 書面審查資料
                  var idx = Math.floor((this.fileIdx - 600)/10);
                  var aLen = ((this.majInfo != null) && (0 < this.majInfo.length) ? this.majInfo.length : 0);

                  if (this.majInfo == null) {
                    this.majInfo = [];
                  }

                  if (aLen <= idx) {
                    for (var x = aLen; x <= idx; x++) {
                      this.majInfo[x] = [];
                    }
                  }

                  if (this.majInfo[idx] != null) {
                    this.majInfo[idx].push(file.response[0]);
                  } else {
                    this.majInfo[idx] = [file.response[0]];
                  }
                } else if ((this.fileIdx >= 700) && (this.fileIdx < 800)) {  // 書面審查選繳資料
                  var idx = Math.floor((this.fileIdx - 700)/10);
                  var aLen = ((this.minInfo != null) && (0 < this.minInfo.length) ? this.minInfo.length : 0);

                  if (this.minInfo == null) {
                    this.minInfo = [];
                  }

                  if (aLen <= idx) {
                    for (var x = aLen; x <= idx; x++) {
                      this.minInfo[x] = [];
                    }
                  }

                  if (this.minInfo[idx] != null) {
                    this.minInfo[idx].push(file.response[0]);
                  } else {
                    this.minInfo[idx] = [file.response[0]];
                  }
                }
                break;
      }
    },
    handleChangeF2(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info2) {
        var len = this.info2.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info2[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info2.splice(idx,1);
        }
      }
    },
    handleChangeF3(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info5) {
        var len = this.info5.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info5[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info5.splice(idx,1);
        }
      }
    },
    handleChangeF4(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info3) {
        var mtLen = this.info3.length;
        var mtIdx = -1;
        var dtIdx = -1;

        for (var i = 0; i < mtLen&&mtIdx<0; i++) {
          var dtLen = this.info3[i].length;
          for (var j = 0; j < dtLen&&dtIdx<0; j++) {
            if (this.info3[i][j].tempName == file.name) {
              mtIdx = i;
              dtIdx = j;
            }
          }
        }
        if ((-1 < mtIdx) && (-1 < dtIdx)) {
          this.info3[mtIdx].splice(dtIdx,1);
        }
      }
    },
    handleChangeF6(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.othInfo) {
        var mtLen = this.othInfo.length;
        var mtIdx = -1;
        var dtIdx = -1;

        for (var i = 0; i < mtLen&&mtIdx<0; i++) {
          var dtLen = this.othInfo[i].length;
          for (var j = 0; j < dtLen&&dtIdx<0; j++) {
            if (this.othInfo[i][j].tempName == file.name) {
              mtIdx = i;
              dtIdx = j;
            }
          }
        }
        if ((-1 < mtIdx) && (-1 < dtIdx)) {
          this.othInfo[mtIdx].splice(dtIdx,1);
        }
      }
    },
    handleChangeF7(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.majInfo) {
        var mtLen = this.majInfo.length;
        var mtIdx = -1;
        var dtIdx = -1;

        for (var i = 0; i < mtLen&&mtIdx<0; i++) {
          var dtLen = this.majInfo[i].length;
          for (var j = 0; j < dtLen&&dtIdx<0; j++) {
            if (this.majInfo[i][j].tempName == file.name) {
              mtIdx = i;
              dtIdx = j;
            }
          }
        }
        if ((-1 < mtIdx) && (-1 < dtIdx)) {
          this.majInfo[mtIdx].splice(dtIdx,1);
        }
      }
    },
    handleChangeF8(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.minInfo) {
        var mtLen = this.minInfo.length;
        var mtIdx = -1;
        var dtIdx = -1;

        for (var i = 0; i < mtLen&&mtIdx<0; i++) {
          var dtLen = this.minInfo[i].length;
          for (var j = 0; j < dtLen&&dtIdx<0; j++) {
            if (this.minInfo[i][j].tempName == file.name) {
              mtIdx = i;
              dtIdx = j;
            }
          }
        }
        if ((-1 < mtIdx) && (-1 < dtIdx)) {
          this.minInfo[mtIdx].splice(dtIdx,1);
        }
      }
    },
    handleChangeF11(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info6) {
        var len = this.info6.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info6[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info6.splice(idx,1);
        }
      }
    },
    handleChangeF12(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info7) {
        var len = this.info7.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info7[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info7.splice(idx,1);
        }
      }
    },
    handleChangeF13(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info8) {
        var len = this.info8.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info8[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info8.splice(idx,1);
        }
      }
    },
    addTmpFile(fileInfo, type) {
        var tIdx = (null == fileInfo ? 0 : fileInfo.length);
        if(tIdx<10)
        {
          var elements = { index: (null == fileInfo ? 1 : fileInfo.length + 1), descr: '', info: null, status: 'A', type: type, id: (tIdx+1)*-1 };

          if (fileInfo == null) {
              var arry1 = [elements];

              fileInfo = arry1;
          }
          else {
              fileInfo.push(elements);
          }
        }
    },
    addDocRow(index) {
      switch (index) {
        case 0:
                this.addTmpFile(this.noInfo.info3.info, 5);
                break;
        case 1:
                this.addTmpFile(this.noInfo.othersInfo.info, 7);
                break;
        case 2:
                this.addTmpFile(this.noInfo.majorInfo.info, 9);
                break;
        case 3:
                this.addTmpFile(this.noInfo.minorInfo.info, 10);
                break;
      }
    }
  },
  filters: {
  },
  created () {
    console.log('======created FileView=====');
    this.loadFileList();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-alert__title
{
  font-size: 2rem;
  line-height: 18px;
}

.file_table_bc
{
  background: #f0f5e5;
}
</style>



// WEBPACK FOOTER //
// src/components/FileView.vue